module.exports = __webpack_public_path__ + "img/uncommon.13fa2721.png";